// extracted by mini-css-extract-plugin
module.exports = {"categoryInfo":"categories_categoryInfo__o7fcW","categoryBtn":"categories_categoryBtn__r1E_0","root":"categories_root__SbW36 bg-white"};